import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import UpdatePassword from '../updatePassword';

import { addLocale } from '../misc';
import request from '../utils/request';

const PrivateRoute = ({ locale, component: Component, ...rest }) => {
  const token = localStorage.accessToken;
  const addLocaleToUrl = addLocale(locale);
  const isPasswordChangeRequired = request.getPasswordUpdate();

  const getRoute = props => {
    if (token) {
      return isPasswordChangeRequired ? (
        <Route
          {...rest}
          path={addLocaleToUrl('/update-password')}
          component={UpdatePassword}
        />
      ) : (
        <Component {...props} locale={locale} />
      );
    }
    return <Redirect to={addLocaleToUrl('/login')} />;
  };
  return <Route {...rest} render={props => getRoute(props)} />;
};

PrivateRoute.propTypes = {
  locale: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
};

export default PrivateRoute;
